import React from 'react';
import {BrowserRouter, Routes, Route} from 'react-router-dom';

import './App.css';
import SayHello from "./templates/Main/SayHello/SayHello";
import CardsStack from "./templates/Games/CardsStack/CardsStack";
import Loading from "./templates/Main/Loading/Loading";
import MainTools from "./templates/Tools/MainTools";
import BlogHome from "./templates/Blog/BlogHome";

function App() {
    return (
        <BrowserRouter>
            <div className="container">
                <Routes>
                    <Route path="/Loading" element={<Loading/>}/>
                    <Route path="/Home" element={<BlogHome />} />
                    <Route path="/CardsStack" element={<CardsStack />} />
                    <Route path="/Tools" element={<MainTools />} />
                    <Route path="/Welcome" element={<SayHello />} />
                    <Route path="/" element={<BlogHome />} />
                </Routes>
            </div>
        </BrowserRouter>
    );
}

export default App;
